export default __webpack_public_path__ + "static/1_35-bb05a440c48cdd366f94ebf81112ad15.png";